export const FETCH_DRIVER = 'FETCH_DRIVER'
export const CLEAR_DRIVERS = 'CLEAR_DRIVERS'
export const FETCH_DRIVER_ERROR = 'FETCH_DRIVER_ERROR'
export const FETCH_RECENT_DRIVERS = 'FETCH_RECENT_DRIVERS'
